import './main-page-skelton.css'

export default function Skeleton() {
    return (
        <>
            <div style={{padding: '10px', display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', paddingBottom: '0'}}>
                <div className='location-container'>
                    <div style={{display:'flex', flexDirection:'row', alignItems:'baseline'}}>
                        <div className='skelton-body' style={{ width:'120px', height:'16px', borderRadius:'10px', marginBottom:'4px' }}></div>
                        <div className='skelton-body' style={{ width:'80px', height:'16px', borderRadius:'10px', marginLeft:'8px' }}></div>
                    </div>
                    <div className='address-container'>
                        <div className='skelton-body' style={{ width:'150px', height:'16px', borderRadius:'10px' }}></div>
                    </div>
                </div>
                <div style={{display:'flex', flexDirection:'column', alignItems:'center', gap:'4px'}}>
                    <div className='open-icon'></div>
                    <div className='open-icon'></div>
                    <div className='open-icon'></div>
                </div>
            </div>
            <div>
                <div className='header-main-container-bottom skelton-body' style={{ width:'95%', height:'45px', borderRadius:'10px', margin:'10px 5px' }}>
                    <div className='header-main-search-text' style={{ opacity: 0.5 }}>Search for <span style={{fontWeight:'bold'}}>"Sugar"</span></div>
                </div>

                <div className="poster-skelton"></div>
                <div>
                    <div className="name-see-all-skeleton">
                        <div className="skelton-body" style={{ width:'170px', height:'20px', borderRadius:'5px' }}></div>
                        <div className="skelton-body" style={{ width:'50px', height:'20px', borderRadius:'5px' }}></div>
                    </div>
                    <div className="horizontal-list-skeleton">
                        <div className="skelton-body" style={{ height: '240px', width: '150px', borderRadius: '10px', flex:'0 0 auto'}}></div>
                        <div className="skelton-body" style={{ height: '240px', width: '150px', borderRadius: '10px', flex:'0 0 auto' }}></div>
                        <div className="skelton-body" style={{ height: '240px', width: '150px', borderRadius: '10px', flex:'0 0 auto' }}></div>
                        <div className="skelton-body" style={{ height: '240px', width: '150px', borderRadius: '10px', flex:'0 0 auto'}}></div>
                        <div className="skelton-body" style={{ height: '240px', width: '150px', borderRadius: '10px', flex:'0 0 auto' }}></div>
                        <div className="skelton-body" style={{ height: '240px', width: '150px', borderRadius: '10px', flex:'0 0 auto' }}></div>
                    </div>
                </div>
                <div>
                    <div className="name-see-all-skeleton">
                        <div className="skelton-body" style={{ width:'170px', height:'20px', borderRadius:'5px' }}></div>
                        <div className="skelton-body" style={{ width:'50px', height:'20px', borderRadius:'5px' }}></div>
                    </div>
                    <div className="horizontal-list-skeleton">
                        <div className="skelton-body" style={{ height: '240px', width: '150px', borderRadius: '10px', flex:'0 0 auto'}}></div>
                        <div className="skelton-body" style={{ height: '240px', width: '150px', borderRadius: '10px', flex:'0 0 auto' }}></div>
                        <div className="skelton-body" style={{ height: '240px', width: '150px', borderRadius: '10px', flex:'0 0 auto' }}></div>
                        <div className="skelton-body" style={{ height: '240px', width: '150px', borderRadius: '10px', flex:'0 0 auto'}}></div>
                        <div className="skelton-body" style={{ height: '240px', width: '150px', borderRadius: '10px', flex:'0 0 auto' }}></div>
                        <div className="skelton-body" style={{ height: '240px', width: '150px', borderRadius: '10px', flex:'0 0 auto' }}></div>
                    </div>
                </div>
            </div>
        </>
    );
}


